import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getTraderMapCampaigns} from '../../../apis/tradermap_campaign/list'

const useQueryTraderMapCampaign = (active?: boolean) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.tradermap.getTraderMapCampaigns(active),
        queryFn: async () => {
            const {data} = await getTraderMapCampaigns(active)
            return data
        },
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    })

    return {data: data, refetch}
}

export default useQueryTraderMapCampaign
